import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AccountingDiary\DeleteAccountingDiaryController::deleteMethod
* @see app/Http/Controllers/AccountingDiary/DeleteAccountingDiaryController.php
* @route '/api/accounting-diary/{accounting_diary}'
*/
export const deleteMethod = (args: { accounting_diary: string | number | { id: string | number } } | [accounting_diary: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/accounting-diary/{accounting_diary}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\AccountingDiary\DeleteAccountingDiaryController::deleteMethod
* @see app/Http/Controllers/AccountingDiary/DeleteAccountingDiaryController.php
* @route '/api/accounting-diary/{accounting_diary}'
*/
deleteMethod.url = (args: { accounting_diary: string | number | { id: string | number } } | [accounting_diary: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { accounting_diary: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { accounting_diary: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            accounting_diary: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        accounting_diary: typeof args.accounting_diary === 'object'
        ? args.accounting_diary.id
        : args.accounting_diary,
    }

    return deleteMethod.definition.url
            .replace('{accounting_diary}', parsedArgs.accounting_diary.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountingDiary\DeleteAccountingDiaryController::deleteMethod
* @see app/Http/Controllers/AccountingDiary/DeleteAccountingDiaryController.php
* @route '/api/accounting-diary/{accounting_diary}'
*/
deleteMethod.delete = (args: { accounting_diary: string | number | { id: string | number } } | [accounting_diary: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\AccountingDiary\DeleteAccountingDiaryController::undo
* @see app/Http/Controllers/AccountingDiary/DeleteAccountingDiaryController.php
* @route '/api/accounting-diary/{accounting_diary}/undo-delete'
*/
export const undo = (args: { accounting_diary: string | number } | [accounting_diary: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/accounting-diary/{accounting_diary}/undo-delete',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AccountingDiary\DeleteAccountingDiaryController::undo
* @see app/Http/Controllers/AccountingDiary/DeleteAccountingDiaryController.php
* @route '/api/accounting-diary/{accounting_diary}/undo-delete'
*/
undo.url = (args: { accounting_diary: string | number } | [accounting_diary: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { accounting_diary: args }
    }

    if (Array.isArray(args)) {
        args = {
            accounting_diary: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        accounting_diary: args.accounting_diary,
    }

    return undo.definition.url
            .replace('{accounting_diary}', parsedArgs.accounting_diary.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountingDiary\DeleteAccountingDiaryController::undo
* @see app/Http/Controllers/AccountingDiary/DeleteAccountingDiaryController.php
* @route '/api/accounting-diary/{accounting_diary}/undo-delete'
*/
undo.get = (args: { accounting_diary: string | number } | [accounting_diary: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AccountingDiary\DeleteAccountingDiaryController::undo
* @see app/Http/Controllers/AccountingDiary/DeleteAccountingDiaryController.php
* @route '/api/accounting-diary/{accounting_diary}/undo-delete'
*/
undo.head = (args: { accounting_diary: string | number } | [accounting_diary: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteAccountingDiaryController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteAccountingDiaryController